export default __webpack_public_path__ + "static/media/151-security-system.0fac47bb.png";